import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.onResize = this.onResize.bind(this)
    this.onFilterToggle = this.updatePanelWidth.bind(this)
    window.addEventListener("resize", this.onResize)
    window.addEventListener("filter-panel-toggled", this.onFilterToggle)
  }

  disconnect() {
    window.removeEventListener("resize", this.onResize)
    window.removeEventListener("filter-panel-toggled", this.onFilterToggle)
  }

  onResize() {
    if (window.innerWidth < 1200) {
      this.panelTarget.classList.add("hidden")
      this.panelTarget.dataset.currentId = ""
    }
  }

  toggle(event) {
    if (window.innerWidth < 1200) {
      event.preventDefault()
      window.location.href = event.currentTarget.href
      return
    }

    const panel = this.panelTarget
    const characterId = event.currentTarget.dataset.characterId

    if (panel.dataset.currentId === characterId && !panel.classList.contains("hidden")) {
      panel.classList.add("hidden")
      panel.dataset.currentId = ""
    } else {
      panel.classList.remove("hidden")
      panel.dataset.currentId = characterId
      this.updatePanelWidth()
    }
  }

  updatePanelWidth() {
    const filterOpen = document.querySelector(".filter-panel:not(.hidden)")
    if (filterOpen) {
      this.panelTarget.style.width = "min(35vw, 780px)"
    } else {
      this.panelTarget.style.width = "min(54vw, 780px)"
    }
  }
}
